<template>
	<div style="background-color: #fcfcfc;">
		<div style="z-index: 99;  background-color: #fff;position: fixed;width: 100%;box-shadow: 0in 2.25pt 3.75pt;transition: opacity 2s ease-in; ">
			<Myheaderesa></Myheaderesa>
		</div>
		<div style="height: 60px;"></div>
		<div class="course" style="margin-bottom: 60px;">
			<div style="width: 100%;margin-bottom: 30px;overflow: hidden;"><img style="width: 100%;" src="@/images/banner_x_3.png" alt="" /></div>
			<div class="courseli">
				<div class="fliters fleys">
					<ul class="flexs " style="flex-wrap: wrap;">
						<li class="fliterstitle">专业</li>
						<li
							:class="{ choiceactive: zyguid == '' }"
							@click="
								zyguid = '';
								getpositionlist();
								getcourselist();
							"
						>
							全部
						</li>
						<li v-for="(item, index) in zylist" :key="index" @click="changezy(item)" :class="{ choiceactive: item.pro_guid == zyguid }">{{ item.pro_name }}</li>
					</ul>
					<ul class="flexs" style="flex-wrap: wrap;">
						<li class="fliterstitle">岗位</li>
						<li
							:class="{ choiceactive: gwguid == '' }"
							@click="
								gwguid = '';
								getcourselist();
							"
						>
							全部
						</li>
						<li
							v-for="(item, index) in gwlist"
							:key="index"
							@click="
								gwguid = item.PR_GUID;
								getcourselist();
							"
							:class="{ choiceactive: gwguid == item.PR_GUID }"
						>
							{{ item.PR_ProfessionalName }}
						</li>
					</ul>
					<ul class="flexs" style="flex-wrap: wrap;">
						<li class="fliterstitle">等级</li>
						<li
							:class="{ choiceactive: djguid == '' }"
							@click="
								djguid = '';
								getcourselist();
							"
						>
							全部
						</li>
						<li
							v-for="(item, index) in djlist"
							:key="index"
							@click="
								djguid = item.IL_GUID;
								getcourselist();
							"
							:class="{ choiceactive: djguid == item.IL_GUID }"
						>
							{{ item.IL_LevelTitle }}
						</li>
					</ul>
				</div>
				<div class="fliterschoice flexs">
					<div class="flexs">
						<p class="titlesactive">默认排序</p>
						<p>发布时间</p>
						<p>热度</p>
						<p>课时</p>
						<p>未授权</p>
						<p>授权</p>
						<div><el-input placeholder="输入关键词搜索" suffix-icon="el-icon-search" v-model="input1"></el-input></div>
					</div>
					<div style="font-size: 15px;font-weight: 600;">
						找到
						<span style="color: red;">{{ couresetotle }}</span>
						个素材
					</div>
				</div>
				<el-divider></el-divider>
				<div class="courselist flexs">
					<div v-if="coureselist.length == 0" style="width: 100%;"><el-empty description="暂无课程"></el-empty></div>
					<div class="courseitem" v-for="(item, index) in coureselist" :key="item.CO_GUID" @click="gocoudetea(item)">
						<div style="overflow: hidden;">
							<img v-if="item.CO_CoverImgUrl" style="height: 160px;" :src="item.CO_CoverImgUrl" alt="" />
							<img v-else style="height: 160px;" src="https://www.hngtsd.net:65535/appstatic/images/ykc1.png" alt="" />
						</div>
						<div class="courseitems">
							<p class="coursefonts">{{ item.CO_CoursesName }}</p>
							<p style="margin-top: 10px;">
								<span>{{ item.CO_Creator }}</span>
								|{{ item.si_name_cn }}
							</p>
							<div class="flexs courseitemstudy" style="margin-bottom: 0;">
								<p>
									<span class="fa fa-user" style="color: #1BB777;font-size: 16px;"></span>
									<span style="color: red;">{{ item.CO_StudyCount }}</span>
									人学习
								</p>
								<!-- <p style="color: red;">未授权</p> -->
							</div>
						</div>
					</div>
				</div>
				<div style="padding: 20px 0;width: 50%;margin: auto;">
					<el-pagination
						background
						hide-on-single-page
						layout="prev, pager, next"
						prev-text="上一页"
						next-text="下一页"
						:page-size="coureseobj.pageSize"
						:current-page="coureseobj.pageIndex"
						:total="couresetotle"
						@current-change="changecurr"
					></el-pagination>
				</div>
			</div>
		</div>
		<Myfooters></Myfooters>
	</div>
</template>
<script>
import AppOptions from '../config/AppOptions.vue';

import Myheaderesa from '@/components/layout/headeresa.vue';

import Myfooters from '@/components/layout/footers.vue';

import { getGetProfList, getPositionList, getInspectionlevel, getCourseList, getCourseListxqdetails } from '@/request/api/homesview/yunhomes/yunhom.js';

export default {
	components: {
		Myheaderesa,
		Myfooters
	},
	data() {
		return {
			input1: '',
			zyguid: '',
			zylist: [],
			gwguid: '',
			gwlist: [],
			djguid: '',
			djlist: [],
			coureseobj: {
				Types: '',
				pageSize: 10,
				pageIndex: 1,
				CategoryID: '',
				ProfessionalID: '',
				PR_GUID: '',
				CourseName: '',
				si_guid: '',
				Inspectionlevel: ''
			},
			coureselist: [],
			couresetotle: 0
		};
	},
	created() {
		AppOptions.appEmpty = true;
	},
	// beforeRouteLeave(to, from, next) {
	// 	AppOptions.appEmpty = false;
	// 	next();
	// },
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.getprolist();
			this.getinstionlevel();
			this.getcourselist();
		},
		changecurr(val) {
			this.coureseobj.pageIndex = val;
			this.getcourselist();
		},

		getcourselist() {
			this.coureseobj.ProfessionalID = this.zyguid;
			this.coureseobj.PR_GUID = this.gwguid;
			this.coureseobj.Inspectionlevel = this.djguid;
			getCourseList(this.coureseobj).then(res => {
				this.coureselist = res.data.data.list;
				this.couresetotle = res.data.data.totalCount;
			});
		},
		gocoudetea(itm) {
			// console.log(itm.CO_GUID)
			if (localStorage.getItem('usercenter')) {
				this.$router.push('/cours/clouddetea?coguid=' + itm.CO_GUID);
			} else {
				this.$router.push('/user/logins?coguid=' + itm.CO_GUID+'&typepath=1');
			}
		},
		// 专业
		getprolist() {
			getGetProfList().then(res => {
				this.zylist = res.data.data;
				this.getpositionlist();
			});
		},
		changezy(itm) {
			this.zyguid = itm.pro_guid;
			this.gwguid = '';
			this.getpositionlist();
			this.getcourselist();
		},
		// 岗位
		getpositionlist() {
			var pro_guid = this.zyguid;
			getPositionList(pro_guid).then(res => {
				this.gwlist = res.data.data;
			});
		},
		// 等级
		getinstionlevel() {
			getInspectionlevel().then(res => {
				this.djlist = res.data.data;
			});
		}
	}
};
</script>

<style scoped lang="less">
.choiceactive {
	padding: 0 20px;
	border: 1px solid #0054ff;
	border-radius: 30px;
	background: #0054ff;
	color: #fff;
}

/deep/ .el-input {
	height: 30px;

	input {
		height: 100%;
	}

	.el-input__suffix {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

.fliterschoice {
	justify-content: space-between;
	p {
		margin: 0 10px;
		cursor: pointer;
		font-size: 16px;
	}
	.titlesactive {
		color: #0054ff;
		font-weight: 700;
	}
}

/deep/ .el-divider--horizontal {
	margin: 15px 0;
}

.course {
	// min-width: 1400px;
	// width: 1400px;
	// margin: auto;
}

.flexs {
	display: flex;
	align-items: center;
}

.fleys {
	display: flex;
	flex-direction: column;
}

.fliters {
	background: #fff;
	padding: 10px;
	border-radius: 10px;
	font-size: 16px;
	box-shadow: 0px 0px 5px 0px #ccc;
	margin: 40px 0;
	ul {
		padding: 10px 0;
		border-bottom: 1px dashed #ccc;
		li {
			margin: 4px 20px;
			cursor: pointer;
		}
	}
	ul:last-child {
		border-bottom: none;
	}

	.fliterstitle {
		font-size: 18px;
		color: #000;
		margin-right: 20px;
		margin-top: 8px;
	}
}

/deep/ .el-pagination {
	display: flex;
	justify-content: center;
	align-items: center;
}

.courseitems {
	padding: 10px;
	background-color: #f5f5f5;
	height: 110px;
}

.courseli {
	min-width: 1200px;
	width: 1200px;
	margin: auto;
}

.coursefonts {
	font-size: 14px;
	color: #373c41;
	font-weight: 600;
}

.courselist {
	flex-wrap: wrap;

	.courseitemstudy {
		justify-content: space-between;
		margin: 10px 0;
	}

	.courseitem {
		width: 24%;
		margin-right: 1%;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin-bottom: 40px;
		overflow: hidden;
		// height: 230px;

		img {
			width: 100%;
		}
		img:hover {
			transform: scale(1.2);
			transition: all 2s;
		}
	}
}
</style>
